import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { Crown, ArrowRight } from "lucide-react";
import ProfileCard from "@/components/dashboard/ProfileCard";
import ProfileDetailDialog from "@/components/dashboard/ProfileDetailDialog";

// "Destaques" (featured Gold/Silver ads) carousel for the overview. City-aware
// data comes from GET /api/featured (gold ordered before silver). Renders
// nothing when there are no active featured ads so the layout stays clean.
export default function DestaquesCarousel({ sources = [], onSeeAll = () => {} }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [detailId, setDetailId] = useState(null);

  const sourceColor = (key) => (sources.find((s) => s.key === key)?.color) || "#c8aa6e";

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/featured");
      setItems(data.items || []);
    } catch (e) {
      console.debug("featured load failed:", e);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (!loading && items.length === 0) return null;

  return (
    <div className="border border-[#c8aa6e]/30 bg-gradient-to-b from-[#c8aa6e]/[0.07] to-[#18181b]" data-testid="destaques-carousel">
      <div className="px-5 py-3 border-b border-[#c8aa6e]/20 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Crown className="w-4 h-4 text-[#c8aa6e]" strokeWidth={1.5} />
          <span className="label-tiny text-[#c8aa6e]">Destaques · anúncios em posição de topo</span>
        </div>
        <button
          type="button"
          onClick={onSeeAll}
          data-testid="destaques-see-all"
          className="inline-flex items-center gap-1 text-xs text-[#c8aa6e] hover:text-[#d4b982]"
        >
          Ver todos os perfis <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>
      <div className="p-4">
        {loading ? (
          <div className="flex gap-4 overflow-hidden">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="w-[190px] shrink-0 aspect-[4/5] bg-[#27272a]/40 animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="flex gap-4 overflow-x-auto pb-2 snap-x" data-testid="destaques-scroll">
            {items.map((p, i) => (
              <div key={p.id} className="w-[190px] shrink-0 snap-start">
                <ProfileCard p={p} index={i} sourceColor={sourceColor(p.source)} onOpen={setDetailId} testid={`destaque-card-${i}`} />
              </div>
            ))}
          </div>
        )}
      </div>

      <ProfileDetailDialog
        profileId={detailId}
        open={!!detailId}
        onOpenChange={(o) => !o && setDetailId(null)}
      />
    </div>
  );
}
